import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { isConflictError, showApiErrorToast } from '@/utils/errors';
import { createUser } from '../api/users.api';
import type { CreateUserPayload } from '../types/user.types';

export function useCreateUser(onSuccess?: () => void) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: (payload: CreateUserPayload) => createUser(payload),
    onSuccess: () => {
      void refreshRelatedData('user');
      toast.success('User created successfully');
      onSuccess?.();
    },
    onError: (error) => {
      if (isConflictError(error)) return;
      showApiErrorToast(error, 'Failed to create user');
    },
  });
}
